module.exports = "https://static.im-cdn.com/mjc/storefront/Esteem/static/media/Star.1f8b69dc.svg";